const HEX_CHANNEL_PATTERN = /[0-9a-f]{2}/gi;
const HEX_DIGITS_PATTERN = /^#[0-9a-f]+$/i;
// `#rrggbb`, or `#rrggbbaa` whose alpha channel is ignored.
const HEX_COLOR_LENGTHS = [7, 9];

const isHexColor = (color: string) =>
  HEX_COLOR_LENGTHS.includes(color.length) && HEX_DIGITS_PATTERN.test(color);
const HEX_RADIX = 16;
const HEX_CHANNEL_LENGTH = 2;

const toChannels = (hexColor: string) =>
  (hexColor.slice(1, 7).match(HEX_CHANNEL_PATTERN) ?? []).map((channel) =>
    parseInt(channel, HEX_RADIX)
  );

/**
 * Mixes two `#rrggbb` colors, `ratio` 0 returns `from` and 1 returns `to`. Used for the route
 * gradient, which the Maps API cannot draw on a single polyline. Any other color format returns
 * `from` unchanged, so a bad theme value gives a plain line instead of a broken color.
 */
export const interpolateColor = (from: string, to: string, ratio: number) => {
  if (!isHexColor(from) || !isHexColor(to)) {
    return from;
  }

  const fromChannels = toChannels(from);
  const toChannelsList = toChannels(to);

  return `#${fromChannels
    .map((channel, index) =>
      Math.round(channel + ((toChannelsList[index] ?? channel) - channel) * ratio)
        .toString(HEX_RADIX)
        .padStart(HEX_CHANNEL_LENGTH, '0')
    )
    .join('')}`;
};
